import React, { useEffect, useRef, useState } from 'react'
import 'react-quill/dist/quill.snow.css';
import ReactQuill, { Quill } from 'react-quill';
import { useNavigate } from 'react-router-dom';
import ImgCrop from 'antd-img-crop';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid'

import { fetchDestinationNamesAC } from '../../../../../../redux/actions/destinations/destinations.ac';
import useDestinations from '../../../../../hooks/useDestinations';

import { handleDeleteBlob, handleImageUpload, TOUR_PACKAGES_BLOB } from '../../../../../azure/blob';

import { Button, Col, Divider, Form, Image, Input, notification, Row, Select, Spin, Switch, Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons';

import { paymentTypes, tourTypes } from '../../../../../Constants/itemTypes';

import './styles.scss'
import useAttractions from '../../../../../hooks/useAttractions';
import useActivities from '../../../../../hooks/useActivities';
import useEvents from '../../../../../hooks/useEvents';
import { fetchAttractionNamesAC } from '../../../../../../redux/actions/attractions/attractions.ac';
import { fetchActivityNamesAC } from '../../../../../../redux/actions/activities/activities.ac';
import { fetchEventNamesAC } from '../../../../../../redux/actions/events/events.ac';
import { editTourPackage, getTourPackageById } from '../../../../../../redux/api/tourPackages.api';
import { ACTIVE, INACTIVE, PENDING } from '../../../../../Constants/activeStatusType';

const getOptionName = (value) => {
    return value
        .toLowerCase()
        .replace(/_./g, (match) => ' ' + match.charAt(1).toUpperCase())
        .replace(/^\w/, (c) => c.toUpperCase());
};


const tourTypeOPtions = Object.keys(tourTypes).map(key => {
    return {
        label: getOptionName(tourTypes[key]),
        value: key
    };
});

const paymentOptions = Object.keys(paymentTypes).map(key => {
    return {
        label: getOptionName(paymentTypes[key]),
        value: key
    };
});


const quillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image", "video"],
        ["clean"],
        ["formula"],
        [{ size: ["small", false, "large", "huge"] }],
    ],
    clipboard: {
        matchVisual: false
    },
    imageResize: {
        parchment: Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    }
};

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });


const EditTourPackage = () => {
    const [shortDescriptionCharCount, setShortDescriptionCharCount] = useState(0)
    const [longDescriptionCharCount, setLongDescriptionCharCount] = useState(0)
    const [howItWorksCharCount, setHowItWorksCharCount] = useState(0)
    const [notesCharCount, setNotesCharCount] = useState(0)

    const [fileList, setFileList] = useState([])
    const [videoList, setVideoList] = useState([])
    const [thumbnailFile, setThumbnailFile] = useState([]);
    const [itineraryFile, setItineraryFile] = useState([]);

    const [previewImage, setPreviewImage] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);

    const [tourPackage, setTourPackage] = useState({})
    const [loading, setLoading] = useState(false)
    const [isFixedTour, setIsFixedTour] = useState(false)
    const [accommodationTypes, setAccommodationTypes] = useState([])
    const [transportType, setTransportType] = useState('')
    const [loadingText, setLoadingText] = useState('')
    const url = window.location.pathname
    const tourPckageId = url.split('/').pop()

    const topRef = useRef(null);
    const formRef = useRef(null);
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const destinations = useDestinations()
    const destinationNames = destinations.destinationNames
    const attractionNames = useAttractions().attarctionNames
    const activityNames = useActivities().activityNames
    const eventNames = useEvents().eventNames

    useEffect(() => {
        if (destinationNames?.length === 0) {
            dispatch(fetchDestinationNamesAC())
        }

        handleGetTourPackage(tourPckageId)
    }, [])

    useEffect(() => {
        if (destinationNames?.length === 0) {
            dispatch(fetchDestinationNamesAC())
        }

        if (attractionNames?.length === 0) {
            dispatch(fetchAttractionNamesAC())
        }

        if (activityNames?.length === 0) {
            dispatch(fetchActivityNamesAC())
        }

        if (eventNames?.length === 0) {
            dispatch(fetchEventNamesAC())
        }

    }, [])

    useEffect(() => {
        if (tourPackage) {
            const images = tourPackage.packageImages?.split(',')
            const videos = tourPackage.packageVideos?.split(',')
            const thumbnail = tourPackage.thumbnailUrl
            const itinerary = tourPackage.itineraryDownloadUrl

            formRef.current.setFieldsValue({
                packageName: tourPackage.packageName,
                tourType: tourPackage.tourType,
                durationDays: tourPackage.durationDays,
                durationNights: tourPackage.durationNights,
                maxGroupSize: tourPackage.maxGroupSize,
                minAge: tourPackage.minAge,
                maxAge: tourPackage.maxAge,
                tags: tourPackage.tags?.split(','),
                shotDescription: tourPackage.shotDescription,
                packageDescription: tourPackage.packageDescription,
                howItWorks: tourPackage.howItWorks,
                qrCodeUrl: tourPackage.qrCodeUrl,

                destinations: tourPackage.destinations?.map(destination => destination.id),
                attractions: tourPackage.attractions?.map(attraction => attraction.id),
                activities: tourPackage.activities?.map(activity => activity.id),
                events: tourPackage.events?.map(event => event.id),

                notes: tourPackage.notes,
                routeMap: tourPackage.routeMap,
                availableStatus: tourPackage.availableStatus,

                paymentOptions: tourPackage.paymentOptions?.split(','),
                startingPrice: tourPackage.startingPrice,
                discountAmount: tourPackage.discountAmount,
                disvountEnds: tourPackage.disvountEnds,
                priceGuide: tourPackage.priceGuide,
                pricePackage: tourPackage.pricePackage,
                vehicleHatchback: tourPackage.vehicleHatchback,
                vehicleSedan: tourPackage.vehicleSedan,
                vehicleSuv: tourPackage.vehicleSuv,
                vehicleVan: tourPackage.vehicleVan,
                VehicleCoster: tourPackage.VehicleCoster,
                roomSingle: tourPackage.roomSingle,
                roomDouble: tourPackage.roomDouble,
                roomTriple: tourPackage.roomTriple,
                roomFamily: tourPackage.roomFamily,
            })


            if (images?.length > 0) {
                const imageFiles = images.map((image, index) => {
                    return {
                        uid: index,
                        name: getBlobName(image),
                        status: 'done',
                        url: image
                    }
                })
                setFileList(imageFiles)
            }

            if (videos?.length > 0) {
                const videoFiles = videos.map((video, index) => {
                    return {
                        uid: index,
                        name: getBlobName(video),
                        status: 'done',
                        url: video
                    }
                })
                setVideoList(videoFiles)
            }

            if (thumbnail) {
                const thumbnailFile = [{
                    uid: 1,
                    name: getBlobName(thumbnail),
                    status: 'done',
                    url: thumbnail
                }]
                setThumbnailFile(thumbnailFile)
            }

            if (itinerary) {
                const itineraryFile = [{
                    uid: 1,
                    name: getBlobName(itinerary),
                    status: 'done',
                    url: itinerary
                }]
                setItineraryFile(itineraryFile)
            }
        }
    }, [tourPackage])

    const handleGetTourPackage = async (id) => {
        setLoading(true)
        try {
            const pkg = await getTourPackageById(id)
            const packageData = pkg.data[0]
            setTourPackage(packageData)

            setIsFixedTour(packageData.isFixedTour || false)

            if (packageData.isFixedTour && packageData.fixedPackageDetails) {
                try {
                    const parsedDetails = JSON.parse(packageData.fixedPackageDetails)
                    setAccommodationTypes(parsedDetails.accommodationTypes || [])
                    setTransportType(parsedDetails.transportType || '')
                } catch (error) {
                    console.error('Error parsing fixed package details:', error)
                    setAccommodationTypes([])
                    setTransportType('')
                }
            } else {
                setAccommodationTypes([])
                setTransportType('')
            }
        } catch (error) {
            console.error('Error fetching tour pacakge by id', error)
        }
        setLoading(false)
    }

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };
    const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

    const onVideoChange = ({ fileList: newFileList }) => setVideoList(newFileList);

    const onThumbnailChange = ({ fileList: newFileList }) => setThumbnailFile(newFileList);

    const onItineryFileChange = ({ fileList: newFileList }) => setItineraryFile(newFileList);


    function extractSrcFromIframe(iframeString) {
        const srcMatch = iframeString.match(/src="([^"]+)"/);
        return srcMatch ? srcMatch[1] : iframeString;
    }

    const onFinish = async (values) => {
        topRef.current.scrollTo(0, 0);
        setLoading(true);
        try {
            Object.keys(values).forEach(key => (values[key] === undefined || values[key] === '' || values[key] === null) && delete values[key]);

            let imageUrls = [];
            let videoUrls = [];
            let thumbnailUrl = '';
            let itineraryUrl = '';

            // find new images and list images need to be deleted
            const newImages = fileList.filter(file => !file.url);
            const deletedImages = tourPackage.packageImages?.split(',').filter(image => !fileList.find(file => file.url === image));

            // find new videos and list videos need to be deleted
            const newVideos = videoList.filter(file => !file.url);
            const deletedVideos = tourPackage.packageVideos?.split(',').filter(video => !videoList.find(file => file.url === video));

            // find new thumbnail and list thumbnail need to be deleted
            const newThumbnail = thumbnailFile.filter(file => !file.url);
            const deletedThumbnail = tourPackage.thumbnailUrl?.split(',').filter(thumbnail => !thumbnailFile.find(file => file.url === thumbnail));

            // find new itinerary and list itinerary need to be deleted
            const newItinerary = itineraryFile.filter(file => !file.url);
            const deletedItinerary = tourPackage.itineraryDownloadUrl?.split(',').filter(itinerary => !itineraryFile.find(file => file.url === itinerary));

            // Upload images
            if (newImages.length > 0) {
                setLoadingText('Uploading Images');
                const imageUploadPromises = newImages.map(async (file, index) => {
                    setLoadingText(`Uploading image ${index + 1}`);

                    let id = uuidv4();
                    id = id.replace(/-/g, '');
                    let extention = file?.name?.split('.').pop();
                    let name = `${id}.${extention}`;

                    return handleImageUpload(
                        TOUR_PACKAGES_BLOB,
                        file.originFileObj,
                        file.size,
                        name
                    ).then(blobRes => {
                        imageUrls.push(blobRes.blockBlobClient.url);
                        setLoadingText(`Uploaded image ${index + 1}`);
                    });
                });
                await Promise.all(imageUploadPromises);
            }

            // Upload videos
            if (newVideos.length > 0) {
                setLoadingText('Uploading Videos');
                const videoUploadPromises = newVideos.map((file, index) => {
                    setLoadingText(`Uploading video ${index + 1}`);

                    let id = uuidv4();
                    id = id.replace(/-/g, '');
                    let extention = file?.name?.split('.').pop();
                    let name = `${id}.${extention}`;

                    return handleImageUpload(
                        TOUR_PACKAGES_BLOB,
                        file.originFileObj,
                        file.size,
                        name
                    ).then(blobRes => {
                        videoUrls.push(blobRes.blockBlobClient.url);
                        setLoadingText(`Uploaded video ${index + 1}`);
                    });
                });
                await Promise.all(videoUploadPromises);
            }

            if (newThumbnail?.length > 0) {
                setLoadingText('Uploading Thumbnail');
                const thumbnailUploadPromises = newThumbnail.map(async (file, index) => {
                    setLoadingText(`Uploading thumbnail ${index + 1}`);

                    let id = uuidv4();
                    id = id.replace(/-/g, '');
                    let extention = file?.name?.split('.').pop();
                    let name = `${id}.${extention}`;

                    return handleImageUpload(
                        TOUR_PACKAGES_BLOB,
                        file.originFileObj,
                        file.size,
                        name
                    ).then((response) => {
                        thumbnailUrl = response.blockBlobClient.url;
                    });
                });
                await Promise.all(thumbnailUploadPromises);
            }

            // Upload Itinerary
            if (newItinerary?.length > 0) {
                setLoadingText('Uploading Itinerary');
                const thumbnailUploadPromises = newItinerary.map(async (file, index) => {
                    setLoadingText(`Uploading itinerary ${index + 1}`);

                    let id = uuidv4();
                    id = id.replace(/-/g, '');
                    let extention = file?.name?.split('.').pop();
                    let name = `${id}.${extention}`;

                    return handleImageUpload(
                        TOUR_PACKAGES_BLOB,
                        file.originFileObj,
                        file.size,
                        name
                    ).then((response) => {
                        itineraryUrl = response.blockBlobClient.url;
                    });
                });
                await Promise.all(thumbnailUploadPromises);
            }

            // delete blobs
            if (deletedImages?.length > 0) {
                setLoadingText('Deleting Images');
                const imageDeletePromises = deletedImages.map(async (image, index) => {
                    const blobName = getBlobName(image);
                    setLoadingText(`Deleting image ${index + 1}`);
                    return handleDeleteBlob(TOUR_PACKAGES_BLOB, blobName);
                });
                await Promise.all(imageDeletePromises);
            }

            if (deletedVideos?.length > 0) {
                setLoadingText('Deleting Videos');
                const videoDeletePromises = deletedVideos.map(async (video, index) => {
                    const blobName = getBlobName(video);
                    setLoadingText(`Deleting video ${index + 1}`);
                    return handleDeleteBlob(TOUR_PACKAGES_BLOB, blobName);
                });
                await Promise.all(videoDeletePromises);
            }

            if (deletedThumbnail?.length > 0) {
                setLoadingText('Deleting Thumbnail');
                const thumbnailDeletePromises = deletedThumbnail.map(async (thumbnail, index) => {
                    const blobName = getBlobName(thumbnail);
                    setLoadingText(`Deleting thumbnail ${index + 1}`);
                    return handleDeleteBlob(TOUR_PACKAGES_BLOB, blobName);
                });
                await Promise.all(thumbnailDeletePromises);
            }

            if (deletedItinerary?.length > 0) {
                setLoadingText('Deleting Itinerary');
                const itineraryDeletePromises = deletedItinerary.map(async (itinerary, index) => {
                    const blobName = getBlobName(itinerary);
                    setLoadingText(`Deleting itinerary ${index + 1}`);
                    return handleDeleteBlob(TOUR_PACKAGES_BLOB, blobName);
                });
                await Promise.all(itineraryDeletePromises);
            }

            let updatedImages = [
                ...fileList.filter((file) => file.url).map((file) => file.url),
                ...imageUrls
            ];

            let updatedVideos = [
                ...videoList.filter((file) => file.url).map((file) => file.url),
                ...videoUrls
            ];

            let updatedThumbnail = thumbnailUrl || (thumbnailFile[0]?.url || '')

            let updatedItinerary = itineraryUrl || (itineraryFile[0]?.url || '')

            updatedImages.forEach((url, index) => {
                updatedImages[index] = sanitizeBlobUrls(url);
            });

            updatedVideos.forEach((url, index) => {
                updatedVideos[index] = sanitizeBlobUrls(url);
            });

            updatedThumbnail = sanitizeBlobUrls(updatedThumbnail);

            updatedItinerary = sanitizeBlobUrls(updatedItinerary);

            if (values.routeMap) {
                values.routeMap = extractSrcFromIframe(values.routeMap);
            }

            const data = {
                id: tourPckageId,
                packageName: values.packageName,
                tourType: values.tourType,
                durationDays: values.durationDays,
                durationNights: values.durationNights,
                maxGroupSize: values.maxGroupSize,
                minAge: values.minAge,
                maxAge: values.maxAge,
                destinations: values.destinations?.join(',') || null,
                attractions: values.attractions?.join(',') || null,
                activities: values.activities?.join(',') || null,
                events: values.events?.join(',') || null,
                tags: values.tags?.join(','),
                shotDescription: values.shotDescription,
                packageDescription: values.packageDescription,
                howItWorks: values.howItWorks,
                notes: values.notes,
                routeMap: values.routeMap,
                paymentOptions: values.paymentOptions?.join(','),
                availableStatus: values.availableStatus,
                packageImages: updatedImages?.length > 0 ? updatedImages.join(',') : null,
                packageVideos: updatedVideos?.length > 0 ? updatedVideos.join(',') : null,
                thumbnailUrl: updatedThumbnail === '' ? null : updatedThumbnail,
                itineraryDownloadUrl: updatedItinerary === '' ? null : updatedItinerary,
                discountAmount: values.discountAmount || null,
                disvountEnds: values.discountAmount ? values.disvountEnds : null,
                priceGuide: values.priceGuide,
                pricePackage: values.pricePackage,
                vehicleHatchback: values.vehicleHatchback,
                vehicleSedan: values.vehicleSedan,
                vehicleSuv: values.vehicleSuv,
                vehicleVan: values.vehicleVan,
                VehicleCoster: values.VehicleCoster,
                roomSingle: values.roomSingle,
                roomDouble: values.roomDouble,
                roomTriple: values.roomTriple,
                roomFamily: values.roomFamily,
                startingPrice: values.startingPrice,
                qrCodeUrl: values.qrCodeUrl,
                isFixedTour: isFixedTour
            }

            if (isFixedTour) {
                if (accommodationTypes.length === 0 || !transportType) {
                    api.error({
                        message: 'Missing Fixed Tour Details',
                        description: 'Please provide accommodation types and transport type for fixed tour packages'
                    });
                    setLoading(false);
                    return;
                }

                data.fixedPackageDetails = JSON.stringify({
                    accommodationTypes: accommodationTypes,
                    transportType: transportType
                });
            }

            setLoadingText('Updating Database');
            const response = await editTourPackage(data);
            if (response.status === 200) {
                api.success({
                    message: 'Tour Package Updated Successfully',
                    description: 'You have successfully updated the tour package'
                });

                setTimeout(() => {
                    navigate(`/dashboard/tours/tour-packages/${tourPckageId}`);
                }, 2000);
            } else {
                api.error({
                    message: 'Error Updating Tour Package',
                    description: 'There was an error updating the tour package. Please try again'
                });
            }
        } catch (error) {
            console.log('Error Updating Tour Package', error);
            api.error({
                message: 'Error Updating Tour Package',
                description: 'There was an error updating the tour package. Please try again'
            });
        }
        setLoading(false);
    };


    const sanitizeBlobUrls = (blobUrl) => {
        const splitUrl = blobUrl.split('?')
        return splitUrl[0]
    }

    const getBlobName = (blobUrl) => {
        const splitUrl = blobUrl.split('/')
        return splitUrl[splitUrl.length - 1]
    }

    const destinationOptions = Object.keys(destinationNames).map(key => {
        return {
            label: getOptionName(destinationNames[key].destinationName),
            value: destinationNames[key].id
        };
    });

    const attractionOptions = Object.keys(attractionNames).map(key => {
        return {
            label: getOptionName(attractionNames[key].attractionName),
            value: attractionNames[key].id
        };
    });

    const activityOptions = Object.keys(activityNames).map(key => {
        return {
            label: getOptionName(activityNames[key].activityName),
            value: activityNames[key].id
        };
    });

    const eventOptions = Object.keys(eventNames).map(key => {
        return {
            label: getOptionName(eventNames[key].eventName),
            value: eventNames[key].id
        };
    })

    return (
        <div className='add__destination' ref={topRef}>
            {contextHolder}
            <h2>
                Edit Tour Package
            </h2>

            <Spin spinning={loading} tip={loadingText}>
                <Form
                    layout='vertical'
                    onFinish={onFinish}
                    ref={formRef}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Name'
                                name='packageName'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter tour package name'
                                    }
                                ]}
                            >
                                <Input placeholder='Tour Package Name' showCount maxLength={200} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Tags'
                                name='tags'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add package tags'
                                    }
                                ]}
                            >
                                <Select
                                    mode="tags"
                                    showSearch
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add Package Tags"
                                    options={[]}
                                    maxCount={5}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Type'
                                name='tourType'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select tour type'
                                    }
                                ]}
                            >
                                <Select
                                    showSearch
                                    allowClear
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Select Tour Type"
                                    options={tourTypeOPtions}
                                    maxCount={1}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Package Type'
                                name='isFixedTour'
                                valuePropName='checked'
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span>Regular Tour</span>
                                    <Switch
                                        checked={isFixedTour}
                                        onChange={(checked) => setIsFixedTour(checked)}
                                    />
                                    <span>Fixed Tour Package</span>
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Duration (Days)'
                                name='durationDays'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add accommodation city'
                                    }
                                ]}
                            >
                                <Input placeholder='Tour Package Duration' type='number' />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Duration (Nights) (* > 1)'
                                name='durationNights'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add accommodation city'
                                    }
                                ]}
                            >
                                <Input min={1} placeholder='Tour Package Duration' type='number' />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={isFixedTour ? 'Group Size (Min 1)' : 'Max Group Size (Min 1)'}
                                name='maxGroupSize'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add max group size'
                                    }
                                ]}
                            >
                                <Input placeholder='Max Group Size' type='number' min={1} />
                            </Form.Item>
                        </Col>
                    </Row>

                    {isFixedTour && (
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label='Accommodation Types'
                                    rules={[
                                        {
                                            required: isFixedTour,
                                            message: 'Please add accommodation types for fixed tour'
                                        }
                                    ]}
                                >
                                    <Select
                                        mode="tags"
                                        style={{ width: '100%' }}
                                        placeholder="Add accommodation types (e.g., 5-star hotel, boutique resort)"
                                        value={accommodationTypes}
                                        onChange={setAccommodationTypes}
                                        maxTagCount={3}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label='Transport Type'
                                    rules={[
                                        {
                                            required: isFixedTour,
                                            message: 'Please add transport type for fixed tour'
                                        }
                                    ]}
                                >
                                    <Input
                                        placeholder="Transport type (e.g., air-conditioned luxury van)"
                                        value={transportType}
                                        onChange={(e) => setTransportType(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Min Age of Travellers'
                                name='minAge'
                            >
                                <Input placeholder='Min Age of Travellers' type='number' />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Max Age of Travellers'
                                name='maxAge'
                            >
                                <Input placeholder='Max Age of Travellers' type='number' />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Destinations'
                                name='destinations'
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Add Package Destinations"
                                    options={destinationOptions}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Attractions'
                                name='attractions'
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Add Package Attractions"
                                    options={attractionOptions}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Activities'
                                name='activities'
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add Package Activities"
                                    options={activityOptions}
                                    filterOption={(input, option) => { (option?.label ?? '').toLowerCase().includes(input.toLowerCase()) }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Events'
                                name='events'
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add Package Events"
                                    options={eventOptions}
                                    filterOption={(input, option) => { (option?.label ?? '').toLowerCase().includes(input.toLowerCase()) }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Add Route Map Embed Code'
                                name='routeMap'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add route map'
                                    }]}
                            >
                                <Input.TextArea placeholder='Add Route Map Embed Code' />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider />

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={`Tour Package Short Description ( ${shortDescriptionCharCount}/1000 characters)`}
                                name='shotDescription'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter tour package short description'
                                    }
                                ]}
                            >
                                <ReactQuill
                                    theme="snow"
                                    limits={{ maxLength: 500 }}
                                    onChange={(content, delta, source, editor) => {
                                        setShortDescriptionCharCount(editor.getLength())
                                    }}
                                    modules={quillModules}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={`Tour Package Description ( ${longDescriptionCharCount}/10000 characters)`}
                                name='packageDescription'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter tour package description'
                                    }
                                ]}
                            >
                                <ReactQuill
                                    theme="snow"
                                    limits={{ maxLength: 10000 }}
                                    onChange={(content, delta, source, editor) => {
                                        setLongDescriptionCharCount(editor.getLength())
                                    }}
                                    modules={quillModules}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={`How it works ( ${howItWorksCharCount}/10000 characters)`}
                                name='howItWorks'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter how it works'
                                    }
                                ]}
                            >
                                <ReactQuill
                                    theme="snow"
                                    limits={{ maxLength: 10000 }}
                                    onChange={(content, delta, source, editor) => {
                                        setHowItWorksCharCount(editor.getLength())
                                    }}
                                    modules={quillModules}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={`Notes ( ${notesCharCount}/10000 characters)`}
                                name='notes'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter special notes'
                                    }
                                ]}
                            >
                                <ReactQuill
                                    theme="snow"
                                    limits={{ maxLength: 10000 }}
                                    onChange={(content, delta, source, editor) => {
                                        setNotesCharCount(editor.getLength())
                                    }}
                                    modules={quillModules}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider>{isFixedTour ? 'Fixed Package Pricing' : 'Pricing (Per Person)'}</Divider>

                    {!isFixedTour && <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Starting Price (AUD)'
                                name='startingPrice'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter tour package starting price'
                                    }
                                ]}
                            >
                                <Input placeholder='Tour Package Starting Price' type='number' />
                            </Form.Item>
                        </Col>
                    </Row>}

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Tour Package Price (AUD)'
                                name='pricePackage'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter tour package price'
                                    }
                                ]}
                            >
                                <Input placeholder='Tour Package Price' type='number' />
                            </Form.Item>
                        </Col>
                        {!isFixedTour && <Col span={12}>
                            <Form.Item
                                label='Tour Guide Price (AUD)'
                                name='priceGuide'
                            >
                                <Input placeholder='Tour Guide Price' type='number' />
                            </Form.Item>
                        </Col>}
                    </Row>

                    {!isFixedTour && (
                        <>
                            <Divider>Transport Pricing (Per Person)</Divider>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label='Hatchback (AUD)'
                                        name='vehicleHatchback'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for hatchback'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Hatchback Price' type='number' />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label='Sedan (AUD)'
                                        name='vehicleSedan'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for sedan'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Sedan Price' type='number' />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label='SUV (AUD)'
                                        name='vehicleSuv'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for SUV'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='SUV Price' type='number' />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label='Van (AUD)'
                                        name='vehicleVan'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for van'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Van Price' type='number' />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label='Coster (AUD)'
                                        name='VehicleCoster'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for Coster'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Coster Price' type='number' />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider>Accommodation (Per Person)</Divider>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label='Single Room (AUD)'
                                        name='roomSingle'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for single room'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Single Room Price' type='number' />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label='Double Room (AUD)'
                                        name='roomDouble'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for double room'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Double Room Price' type='number' />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label='Triple Room (AUD)'
                                        name='roomTriple'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for triple room'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Triple Room Price' type='number' />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label='Family Room (AUD)'
                                        name='roomFamily'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter price for family room'
                                            }
                                        ]}
                                    >
                                        <Input placeholder='Family Room Price' type='number' />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )}

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Payment Options'
                                name='paymentOptions'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add payment options'
                                    }
                                ]}
                            >
                                <Select
                                    mode="tags"
                                    showSearch
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add Payment Options"
                                    options={paymentOptions}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider>Descount</Divider>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Discount (%)'
                                name='discountAmount'
                            >
                                <Input placeholder='Tour Package Discount' type='number' />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Discount End Date'
                                name='disvountEnds'
                            >
                                <Input placeholder='Discount End Date' type='date' />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider />

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Upload Ininerary Document'
                                name='itineraryDownloadUrl'
                            >
                                <Upload
                                    listType="picture"
                                    fileList={itineraryFile}
                                    onChange={onItineryFileChange}
                                    multiple={true}
                                    maxCount={3}
                                    beforeUpload={(file) => {
                                        return false;
                                    }}
                                >
                                    {itineraryFile?.length < 1 && <Button icon={<PlusOutlined />}>Upload</Button>}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>


                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Upload Images (Max 10)'
                                name='packageImages'
                            >
                                <Upload
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={handlePreview}
                                    onChange={handleChange}
                                    multiple={true}
                                    maxCount={10}
                                    beforeUpload={(file) => {
                                        return false;
                                    }}
                                >
                                    {fileList.length <= 10 && '+ Upload'}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Upload Videos (Max 3)'
                                name='packageVideos'
                            >
                                <Upload
                                    listType="picture"
                                    fileList={videoList}
                                    onChange={onVideoChange}
                                    multiple={true}
                                    maxCount={3}
                                    beforeUpload={(file) => {
                                        return false;
                                    }}
                                >
                                    {videoList?.length < 3 && <Button icon={<PlusOutlined />}>Upload</Button>}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Upload Thumbnail Image'
                                name='thumbnailUrl'
                            >
                                <ImgCrop
                                    rotationSlider
                                    modalTitle='Crop Image'
                                    modalOk='Crop'
                                    modalCancel='Cancel'
                                    showReset={true}
                                    aspect={16 / 9}
                                >
                                    <Upload
                                        listType="picture-card"
                                        fileList={thumbnailFile}
                                        onChange={onThumbnailChange}
                                        multiple={false}
                                        beforeUpload={(file) => {
                                            return false;
                                        }}
                                    >
                                        {thumbnailFile.length < 1 && '+ Upload'}
                                    </Upload>
                                </ImgCrop>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Available Status'
                                name='availableStatus'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add available status'
                                    }
                                ]}
                            >
                                <Select
                                    mode='single'
                                    showSearch
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add available status"
                                    options={[
                                        {
                                            label: 'Active',
                                            value: ACTIVE
                                        },
                                        {
                                            label: 'Inactive',
                                            value: INACTIVE
                                        },
                                        {
                                            label: 'Pending',
                                            value: PENDING
                                        }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button type='primary' htmlType='submit'>
                            Update Tour Package
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>

            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </div>
    )
}

export default EditTourPackage